//
// Module for the Retirement Setup wizard's Initiate step
//
rs.module("participant/benefit/setup/retirement/wizard/initiatestep",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, flags, backendUrls, backendParams) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var separationTypeSelect = stepContainer.js(jsSelectors.separationTypeSelect, { required: false });
            var disabilityContainer = stepContainer.js(jsSelectors.disabilityContainer, { required: false });
            var disabilitySelect = stepContainer.js(jsSelectors.disabilitySelect, { required: false });
            var disabilitySelectHelper = selectHelper.getHelper(disabilitySelect);
            var separationDateInput = stepContainer.js(jsSelectors.separationDateInput, { required: false });
            var separationDateHidden = stepContainer.js(jsSelectors.separationDateHidden, { required: false });
            var benefitEffectiveDateInput = stepContainer.js(jsSelectors.benefitEffectiveDateInput, { required: false });
            var applyIncomeLevelingCheckBox = stepContainer.js(jsSelectors.applyIncomeLevelingCheckBox, { required: false });
            var socialSecurityBenefitAmountInput = stepContainer.js(jsSelectors.socialSecurityBenefitAmountInput, { required: false });
            var socialSecurityStartAgeInput = stepContainer.js(jsSelectors.socialSecurityStartAgeInput, { required: false });
            var socialSecurityEvidenceFiledCheckbox = stepContainer.js(jsSelectors.socialSecurityEvidenceFiledCheckbox, { required: false });          
            var backDropMonthsSelect = stepContainer.js(jsSelectors.backDropMonthsSelect, { required: false });
            var backDropDateInput = stepContainer.js(jsSelectors.backDropDateInput, { required: false });
            var backDropDateHidden = stepContainer.js(jsSelectors.backDropDateHidden, { required: false });
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox, { required: false });
            var basisPlanSelect = stepContainer.js(jsSelectors.basisPlanSelect, { required: false });
            var splitPlanCalculationCheckBox = stepContainer.js(jsSelectors.splitPlanCalculationCheckBox, { required: false });

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Hookup separationTypeSelect change event
            separationTypeSelect.change(separationTypeChange);

            // Hookup separationDateInput change event
            separationDateInput.change(_.debounce(function () { separationDateChange(); }, 500));

            // Hookup benefitEffectiveDateInput change event
            benefitEffectiveDateInput.change(_.debounce(function () { setBackDropDate(); }, 500));

            // Hookup backDropMonthsSelect change event
            backDropMonthsSelect.change(setBackDropDate);

            // Hookup basisPlanSelect change event
            basisPlanSelect.change(basisPlanChange);

            // Enable/Disable Income Leveling fields on applyIncomeLevelingCheckBox change
            applyIncomeLevelingCheckBox.change(function () {

                // Enable/disable Income Leveling fields
                socialSecurityBenefitAmountInput.prop("disabled", !this.checked).val("").clearErrors();
                socialSecurityStartAgeInput.prop("disabled", !this.checked).val("").clearErrors();
                socialSecurityEvidenceFiledCheckbox.prop("disabled", !this.checked).prop('checked', false);
            });

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });

            // Separation Type change event
            function separationTypeChange() {

                // Get selected Separation Type
                var selectedSeparationType = separationTypeSelect.val();

                // Clear Disability selection errors
                disabilitySelect.clearErrors();

                // Enable/Disable dependent fields
                if (selectedSeparationType == codeValues.disabilityRetirement) {

                    disabilityContainer.show();
                }
                else {
                    disabilityContainer.hide();
                    disabilitySelectHelper.setValue("");
                }
            }

            // Separation Date change event
            function separationDateChange() {

                separationDateInput.clearErrors();

                // Sync the hidden input
                separationDateHidden.val(separationDateInput.val());

                if (separationDateInput.val() && separationDateInput.valid()) {

                    // Get entered Separation Date
                    var separationDate = separationDateInput.val();

                    // If the Separation Date was not system defaulted, populate Effective Date
                    if (flags.isRecalc || !flags.separationDateDefaulted) {
                        var effectiveDate = new Date(separationDate);
                        var newEffectiveDate = new Date(
                            Date.UTC(
                                effectiveDate.getUTCFullYear(),
                                effectiveDate.getUTCMonth() + 1,
                                1,
                                effectiveDate.getUTCHours(),
                                effectiveDate.getUTCMinutes()
                            )
                        );
                        benefitEffectiveDateInput.val(new Date(newEffectiveDate).toISODateString()).clearErrors();
                    }

                    // Set the backDrop date
                    setBackDropDate();
                }
            }

            // Set Back Drop Date
            function setBackDropDate() {

                if (flags.isBackDrop) {

                    if (benefitEffectiveDateInput.val() && benefitEffectiveDateInput.valid() && backDropMonthsSelect.val()) {
                        $.ajax({
                            url: backendUrls.getBackDropDate,
                            data: {
                                benefitEffectiveDate: benefitEffectiveDateInput.val(),
                                backDropMonths: backDropMonthsSelect.val()
                            },
                            success: function (data) {
                                backDropDateInput.val(data.backDropDate);
                                backDropDateHidden.val(data.backDropDate);
                            }
                        });
                    }
                    else {
                        backDropDateInput.val("");
                        backDropDateHidden.val("");
                    }
                }
            }

            // Basis Plan change event
            function basisPlanChange() {
                eventBanner.removeAllMessages();

                var selectedBasisPlanKey = basisPlanSelect.val();

                $.get(backendUrls.updateBasisPlan, {
                    basisPlanKey: selectedBasisPlanKey,
                    fundKey: backendParams.fundKey,
                    isBackDrop: flags.isBackDrop,
                    isDropExit: flags.isDropExit,
                    isRecalc: flags.isRecalc,
                    incomingBenefitClaimPaymentKey: backendParams.incomingBenefitClaimPaymentKey
                })
                    .done(function (response) {

                        // Update Separation Date
                        if (response.separationDate) {
                            var newSeparationDate = new Date(response.separationDate).toISODateString();

                            separationDateInput.val(newSeparationDate).clearErrors();
                            separationDateHidden.val(newSeparationDate);

                            // Trigger downstream recalculations
                            separationDateChange();
                        }
                        else {
                            // Clear if backend returns null
                            separationDateInput.val("").clearErrors();
                            separationDateHidden.val("");
                        }

                        // Update Split Plan flag
                        if (response.splitPlanCalculation !== undefined) {
                            if (response.splitPlanCalculation) {
                                splitPlanCalculationCheckBox.setDisabled(false);
                                splitPlanCalculationCheckBox.setChecked(true).clearErrors();
                            }
                            else {
                                splitPlanCalculationCheckBox.setChecked(false).clearErrors();
                                splitPlanCalculationCheckBox.setDisabled(true);
                            }
                        }
                    })
                    .fail(function () {
                        eventBanner.addDanger("Error updating Basis Plan.");
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);